import { render, staticRenderFns } from "./View.vue?vue&type=template&id=9184ebe8&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9184ebe8')) {
      api.createRecord('9184ebe8', component.options)
    } else {
      api.reload('9184ebe8', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=9184ebe8&", function () {
      api.rerender('9184ebe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/representative/View.vue"
export default component.exports